import { render, staticRenderFns } from "./TeamsportComingMatch.vue?vue&type=template&id=6755f06a&scoped=true"
import script from "./TeamsportComingMatch.vue?vue&type=script&lang=js"
export * from "./TeamsportComingMatch.vue?vue&type=script&lang=js"
import style0 from "./TeamsportComingMatch.vue?vue&type=style&index=0&id=6755f06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755f06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
